import Vue from 'vue';
import { mapGetters } from 'vuex';
import HelpIcon from 'src/components/project/analysis/results/widgets/HelpIcon.vue';
import DownloadExportButton from 'src/components/project/analysis/results/widgets/DownloadExportButton.vue';
import TimelineTrendBase from 'src/components/project/analysis/results/widgets/TimelineTrendBase.vue';
export default Vue.extend({
    components: { HelpIcon, DownloadExportButton },
    extends: TimelineTrendBase,
    computed: {
        ...mapGetters([
            'currentAnalysis', 'analysisTimeline', 'currentModel'
        ]),
        help() {
            return `<p>Graphs the trajectory of this query over time.</p>`;
        }
    },
    methods: {
        // This method can be overwritten if the colour assignments need to change
        _assignColours(timelineData, sortedTimelineKeys) {
            // Assign colours to the objects based on frequency ordered list
            sortedTimelineKeys.forEach((key, idx) => {
                timelineData['Query 1'].colour = 'rgb(17, 172, 223)';
                timelineData['Query 2'].colour = 'rgb(248, 149, 22)';
            });
            return timelineData;
        }
    }
});
